import { Chip } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { StudentStatus, StudyRequestStatus } from '../../interfaces';
import { useTranslation } from '../../services';

const Status: FC<{ status: StudyRequestStatus | StudentStatus | undefined }> = ({
	status,
}) => {
	const { t } = useTranslation();
	const [color, setColor] = useState<
		| 'primary'
		| 'success'
		| 'error'
		| 'default'
		| 'secondary'
		| 'info'
		| 'warning'
		| undefined
	>();
	useEffect(() => {
		switch (status) {
			case StudentStatus.NEW:
			case StudyRequestStatus.PENDING:
				setColor('primary');
				break;
			case StudentStatus.SENT:
			case StudyRequestStatus.APPROVED:
				setColor('success');
				break;
			case StudyRequestStatus.REJECTED:
			case StudentStatus.ERROR:
			case StudentStatus.DEACTIVATED:	
				setColor('error');
				break;
			default:
				setColor(undefined);
				break;
		}
	}, [status]);
	return <Chip label={t(`${status}`)} color={color} variant="outlined" />;
};
export default Status;
